var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40924 1C6.68538 1 6.90924 1.22386 6.90924 1.5C6.90924 1.74546 6.73236 1.94961 6.49911 1.99194L6.40924 2H1.00015V14H13.0001V8.59091C13.0001 8.31477 13.224 8.09091 13.5001 8.09091C13.7456 8.09091 13.9498 8.26778 13.9921 8.50103L14.0001 8.59091V14.5C14.0001 14.78 13.7801 15 13.5001 14.9933L0.500163 15C0.220163 15 -0.00658179 14.78 0.000145943 14.5V1.5C0.000145943 1.22 0.220146 1 0.500146 1H6.40924ZM12.8537 0.146447L14.8537 2.14645C15.049 2.34171 15.049 2.65829 14.8537 2.85355L8.3537 9.35355C8.2839 9.42335 8.195 9.47093 8.0982 9.49029L5.5982 9.99029C5.24834 10.0603 4.93988 9.7518 5.00986 9.40194L5.50986 6.90194C5.52921 6.80515 5.57679 6.71625 5.64659 6.64645L12.1466 0.146447C12.3419 -0.0488155 12.6584 -0.0488155 12.8537 0.146447ZM12.5001 1.20711L6.46075 7.24651L6.13752 8.86262L7.75364 8.5394L13.793 2.5L12.5001 1.20711Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPage);
export default __webpack_public_path__ + "static/media/edit-page.d9de8586d75b04d668f02943ac2bec7f.svg";
export { ForwardRef as ReactComponent };